/**
Copyright 2021 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/
export const LOAD_USER = "LOAD_USER";
export const LOAD_ACCOUNT_AND_USER = "LOAD_ACCOUNT_AND_USER";
export const GET_USER_SKILL_INTEREST = "GET_USER_SKILL_INTEREST";
export const PAGINATE_USER_SKILL_INTEREST = "PAGINATE_USER_SKILL_INTEREST";
export const GET_SKILLS = "GET_SKILLS";
export const PAGINATE_SKILLS = "PAGINATE_SKILLS";
export const DELETE_USER_SKILL_INTEREST = "DELETE_USER_SKILL_INTEREST";